import { render } from "./ApprovalTable.vue?vue&type=template&id=9bf2d9f8"
import script from "./ApprovalTable.vue?vue&type=script&lang=js"
export * from "./ApprovalTable.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__